import React, { useContext } from 'react';

import { Breadcrumb } from '@buildoutinc/blueprint-react/ui/Breadcrumb';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { PageHeaderBandContext } from './band_context';

interface BreadcrumbLink {
  icon?: FontAwesomeIconProps['icon'];
  label?: string;
  href?: string;
}
interface Props {
  breadcrumbs?: BreadcrumbLink[];
  description?: React.ReactNode;
  icon?: FontAwesomeIconProps['icon'];
  imgSrc?: string | null;
  title: React.ReactNode;
}

export default function PageHeaderHeading({ breadcrumbs, description, icon, imgSrc, title }: Props) {
  const band = useContext(PageHeaderBandContext);

  if (band) {
    return (
      <div className="d-flex flex-wrap flex-grow-1 align-items-baseline column-gap-3 row-gap-2" style={{ minWidth: 0 }}>
        {typeof title === 'string' ? <h1 className="fs-4 fw-semibold mb-0 text-truncate">{title}</h1> : title}
        {description && <div className="text-muted fs-small">{description}</div>}
      </div>
    );
  }

  return (
    <div className={classNames('d-flex align-items-start', imgSrc ? 'gap-4' : 'gap-2')}>
      {imgSrc && <img className="rounded" height={82} src={imgSrc} width={164} />}
      {icon && <div className="d-none d-md-block mt-1"><FontAwesomeIcon icon={icon} size="xl" /></div>}
      <div>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb>
            <Breadcrumb.List>
              {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={breadcrumb.href || breadcrumb.label}>
                  <Breadcrumb.Item>
                    {breadcrumb.href ? (
                      <Breadcrumb.Link href={breadcrumb.href}>
                        {breadcrumb.icon && <FontAwesomeIcon icon={breadcrumb.icon} />}
                        {breadcrumb.label}
                      </Breadcrumb.Link>
                    ) : (
                      <Breadcrumb.Page>
                        {breadcrumb.icon && <FontAwesomeIcon icon={breadcrumb.icon} />}
                        {breadcrumb.label}
                      </Breadcrumb.Page>
                    )}
                  </Breadcrumb.Item>
                  {index < breadcrumbs.length - 1 && <Breadcrumb.Separator />}
                </React.Fragment>
              ))}
            </Breadcrumb.List>
          </Breadcrumb>
        )}
        {typeof title === 'string' ? <h5>{title}</h5> : title}
        {description && <div className="text-muted">{description}</div>}
      </div>
    </div>
  );
}
